export default (reference?: any) => {
  setTimeout(() => {
    window.scrollTo({
      behavior: 'smooth',
      top: reference ? reference.current.offsetTop : 0
    });
  }, 100);
}
